<app-pageheader Title="Cluster Designs">
  <add-button AddRoute="settings/clusterdesigns/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="infrastructure/clusterdesigns/searches" [AllowEdit]="true" EditUrl="settings/clusterdesigns/:id/edit">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>